import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedInventoryMoveHistories: [],
};

const inventoryAdjustmentsSlice = createSlice({
	name: 'inventoryAdjustments',
	initialState: initialState,
	reducers: {
		setInventoryAdjustments: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setInventoryAdjustments, reset } = inventoryAdjustmentsSlice.actions;

export default inventoryAdjustmentsSlice.reducer;